module.exports = __webpack_public_path__ + "static/media/SO2210F0.2bb5b73d.png";